<script lang="ts" setup>
	useHead({
		meta: [
			{name: 'geo.placename', content: 'Delitzsch'},
			{name: 'geo.region', content: 'DE-SN'},
			{name: 'theme-color', content: '#0074b7 '},
			{name: 'msapplication-TileColor', content: '#0074b7 '},
			{property: 'og:type', content: 'website'},
			{property: 'og:locale', content: 'de_DE'}
		],
		link: [
			{rel: 'icon', type: 'image/png', sizes: '16x16', content: usePublicUrl('/icons/favicon-16x16.png')},
			{rel: 'icon', type: 'image/png', sizes: '32x32', content: usePublicUrl('/icons/favicon-32x32.png')},
			{rel: 'icon', type: 'image/png', sizes: '192x192', content: usePublicUrl('/icons/android-chrome-192x192.png')},
			{rel: 'icon', type: 'image/png', sizes: '512x512', content: usePublicUrl('/icons/android-chrome-512x512.png')},
			{rel: 'apple-touch-icon', content: usePublicUrl('/icons/apple-touch-icon.png')},
			{rel: 'msapplication-TileImage', content: usePublicUrl('/icons/tileImage-144x144.png')},
			{rel: 'manifest', content: usePublicUrl('/icons/site.webmanifest')}
		],
		script: [
			{
				type: 'application/ld+json',
				textContent: JSON.stringify({
					'@context': 'https://schema.org',
					'@graph': [
						{
							'@type': 'MedicalOrganization',
							'@id': 'https://www.kliniken-delitzsch-eilenburg.de/#organization',
							name: 'Kliniken Delitzsch-Eilenburg',
							url: 'https://www.kliniken-delitzsch-eilenburg.de'
						},
						{
							'@type': 'Hospital',
							'@id': 'https://www.kliniken-delitzsch-eilenburg.de/standort-delitzsch#hospital',
							name: 'Klinik Delitzsch',
							parentOrganization: {
								'@id': 'https://www.kliniken-delitzsch-eilenburg.de/#organization'
							},
							address: {
								'@type': 'PostalAddress',
								streetAddress: 'Dübener Straße 3-9',
              					postalCode: '04509',
								addressLocality: 'Delitzsch',
								addressRegion: 'Sachsen',
								addressCountry: 'DE'
							},
							telephone: '+49 34202 7670',
							geo: {
								'@type': 'GeoCoordinates',
								latitude: '51.526531',
								longitude: '12.337844'
							}
						},
						{
							'@type': 'Hospital',
							'@id': 'https://www.kliniken-delitzsch-eilenburg.de/standort-eilenburg#hospital',
							name: 'Klinik Eilenburg',
							parentOrganization: {
								'@id': 'https://www.kliniken-delitzsch-eilenburg.de/#organization'
							},
							address: {
								'@type': 'PostalAddress',
								streetAddress: 'Wilhelm-Grune-Straße 5-8',
              					postalCode: '04838',
								addressLocality: 'Eilenburg',
								addressRegion: 'Sachsen',
								addressCountry: 'DE'
							},
							telephone: '+49 03423 6670',
							geo: {
								'@type': 'GeoCoordinates',
								latitude: '51.460079',
								longitude: '12.620572'
							}
						}
					]
				})
			}
		]
	})

	const rConf = useRuntimeConfig()
	await Promise.all([
		useFetch('/rest/locations', {baseURL: rConf.public.apiBase, key: 'locations'}),
		useFetch('/rest/subjectareas', {baseURL: rConf.public.apiBase, key: 'subjectareas'}),
		useFetch('/rest/downloadgroups', {baseURL: rConf.public.apiBase, key: 'downloadgroups'}),
		useFetch('/rest/teams', {baseURL: rConf.public.apiBase, key: 'teams'}),
		useFetch('/rest/article-category-items-detail/patienten', {baseURL: rConf.public.apiBase, key: 'linkspatients'}),
		useFetch('/rest/article-category-items-detail/karriere', {baseURL: rConf.public.apiBase, key: 'linkscareer'}),
		useFetch('/rest/article-category-items-detail/unternehmen', {baseURL: rConf.public.apiBase, key: 'linkscompany'}),
	])
	const {data: locations} = useNuxtData('locations')
	const {data: subjectareas} = useNuxtData('subjectareas')
	const {data: linksPatients} = useNuxtData('linkspatients')
	const {data: linksCareer} = useNuxtData('linkscareer')
	const {data: linksCompany} = useNuxtData('linkscompany')

	const currentDate: Date = new Date()

	let subNavPatients = linksPatients.value.map(function (item: any) {
		return {
			label: item['label'] ? item['label'] : item['article']['title'],
			path: `/patienten/${item['article']['slug']}`
		}
	})

	let subNavCareer = linksCareer.value.map(function (item: any) {
		return {
			label: item['label'] ? item['label'] : item['article']['title'],
			path: `/karriere/${item['article']['slug']}`
		}
	})
	let subNavCareerMerge = Array.from(subNavCareer)
	subNavCareerMerge.unshift({label: 'Stellenangebote', path: {name: 'joboffers-list'}})

	let subNavCompany = linksCompany.value.map(function (item: any) {
		return {
			label: item['label'] ? item['label'] : item['article']['title'],
			path: `/unternehmen/${item['article']['slug']}`
		}
	})
	let subNavCompanyMerge = Array.from(subNavCompany)
	subNavCompanyMerge.unshift({label: 'News', path: {name: 'news-list'}})

	// Navigation
	const navigation = {
		patienten: subNavPatients,
		karriere: subNavCareerMerge,
		unternehmen: subNavCompanyMerge
	}

	// Footer Navigation
	const footer_navigation = [
		{label: 'Klinik Delitzsch', path: '/standort-delitzsch'},
		{label: 'Klinik Eilenburg', path: '/standort-eilenburg'},
		{label: 'Fachbereiche', path: '/fachbereiche'},
		{label: 'Stellenangebote', path: {name: 'joboffers-list'}},
		{label: 'Barrierefreiheitserklärung', path: '/barrierefreiheitserklarung'},
		{label: 'Datenschutz', path: '/datenschutzerklarung'},
		{label: 'Hinweisgebersystem', path: '/hinweisgebersystem'},
		{label: 'Impressum', path: '/impressum'},
		{label: 'Kontakt', path: '/kontakt'},
	]

	const header = ref(null)
	const isScrolled = ref<boolean>(false)
	const route = useRoute()
	const drawerOpen = ref(false)
	const { settings, loadSettings } = useAccessibilitySettings()

	onMounted(() => {
	 	loadSettings()
		useEventListener(window, 'scroll', function () {
			isScrolled.value = window.scrollY > header.value?.clientHeight && screen.width > 1020
		})
	})

	watch(route, value => {
		if(drawerOpen.value) {
			drawerOpen.value = false
		}
  	}, {deep: true, immediate: true})

	const logoHeaderSrc = computed(() =>
	  settings.value.contrast === 'high-dark'
		? '/img/logo-default-white.svg'
		: '/img/logo.svg'
	)

	const logoFooterSrc = computed(() =>
	  settings.value.contrast === 'high-light'
		? '/img/logo-black.svg'
		: '/img/logo-white.svg'
	)

	const euSignetFooterSrc = computed(() =>
	  settings.value.contrast === 'high-light'
		? '/img/DE_Funded_by_NextGenEU-black.png'
		: '/img/DE_Funded_by_NextGenEU.png'
	)
</script>

<template>
	<GsApp color-mode-preference="light">

		<AccessibilityModal></AccessibilityModal>

		<NuxtLayout name="site-default">

			<template #header>
				<div :class="{'fixed left-0 top-0 w-full z-40':$screen.gte.lg}">
					<AlertsBanner />
					<div ref="header" :class="{'shadow-lg':isScrolled}" class="bg-white transition duration-300 ease-in-out">
						<GsPageSection as="div" :container-class="['px-4', {'-mt-31.25 lg:-mt-40':isScrolled}]">
							<div class="h-22.5 sm:h-25 md:h-31.25 lg:h-40 flex flex-row justify-between">

								<NuxtLink class="mt-2.5" no-prefetch title="zur Startseite der Website der Kliniken Delitzsch Eilenburg" to="/">
									<img alt="Logo der Kliniken Delitzsch Eilenburg"
									     class="w-32.5 sm:w-37.5 md:w-50 lg:w-63.75"
									     data-not-lazy
									     height="135" :src="usePublicUrl(logoHeaderSrc)" :key="logoHeaderSrc" width="255"
									/>
								</NuxtLink>

								<div>
									<div v-show="$screen.gte.lg"
									     class="mt-2.5 flex flex-row space-x-3 lg:space-x-5 items-right">
										<NuxtLink class="text-sm text-primary hover:text-accent-100 transition duration-300"
										          no-prefetch
										          to="/kontakt">Kontakt
										</NuxtLink>
										<NuxtLink class="text-sm text-primary hover:text-accent-100 transition duration-300"
										          no-prefetch
										          to="/datenschutzerklarung">Datenschutz
										</NuxtLink>
										<NuxtLink class="text-sm text-primary hover:text-accent-100 transition duration-300"
										          no-prefetch
										          to="/impressum">Impressum
										</NuxtLink>
									</div>
									<template v-if="locations && locations.length">
										<div class="sr-only">
											<section v-for="(l,idx) in locations" :key="idx" :aria-label="'Schnellkontakt zur Klinik ' + l.name"
											         class="text-xs">
												<span class="font-bold block">Klinik {{ l.name }}</span>
												<span v-if="l.phone_number"
												      class="block"><label>Telefon: </label>{{ l.phone_number }}</span>
												<span v-if="l.fax_number"
												      class="block"><label>Fax: </label>{{ l.fax_number }}</span>
												<span v-if="l.email_address"
												      class="block"><label>E-Mail Adresse: </label><a
													:href="'mailto:'+l.email_address"
													title="E-Mail schreiben">{{ l.email_address }}</a></span>
											</section>
										</div>
									</template>
								</div>

								<div v-if="$screen.lt.lg" class="flex">
									<UDrawer
										direction="left"
										:ui="{
											content: 'bg-white w-full xs:w-auto max-w-none',
											container: 'bg-white',
										}"
										v-model:open="drawerOpen"
									>
										<UButton :square="true" variant="solid" color="primary" class="rounded-full p-0! size-12 md:size-16 flex my-auto items-center" title="Navigation öffnen" aria-label="Navigation öffnen">
											<GsIcon name="fa6-solid:bars" class="size-6 md:size-8 me-0!"></GsIcon>
										</UButton>

										 <template #header>
											 <h2 class="sr-only">Navigation</h2>
											 <div class="w-full flex justify-end mb-8">
											 	<GsBtn icon="material-symbols:close" class="flex self-end [&_.iconify]:size-8" variant="link" color="neutral" @click="drawerOpen = false" />
											 </div>
										</template>

										<template #body>
											<div class="w-full xs:w-80 sm:w-95 h-full relative">
												<nav role="navigation">
													<GsList separator="divide-primary-200" tag="ul">

														<GsExpansionItem
															class="font-bold text-xl text-primary hover:text-accent-100"
															label="Patientenbereich">
															<GsList class="ml-4 mb-4" tag="ul">
																<template v-if="navigation && navigation.patienten">
																	<GsItem
																		v-for="(item,idx) in navigation.patienten"
																		:key="idx"
																		:to="item.path"
																		no-prefetch
																	>
																		<GsItemSection
																			class="text-[1rem] lg:text-xl text-primary hover:text-accent-100"
																		>
																			{{ item.label }}
																		</GsItemSection>
																	</GsItem>
																</template>
															</GsList>
														</GsExpansionItem>

														<GsExpansionItem
															class="font-bold text-xl text-primary hover:text-accent-100"
															label="Fachbereiche">
															<GsList class="ml-4 mb-4" tag="ul">
																<template v-if="subjectareas && subjectareas.length">
																	<GsItem
																		v-for="obj in subjectareas"
																		:key="obj.id"
																		:to="{name: 'fachbereiche-slug', params: {slug: obj.slug}}"
																		no-prefetch
																	>
																		<GsItem-section
																			class="text-[1rem] lg:text-xl text-primary hover:text-accent-100"
																		>
																			{{ obj.title }}
																		</GsItem-section>
																	</GsItem>
																</template>
															</GsList>
														</GsExpansionItem>

														<GsExpansionItem v-if="locations && locations.length"
																		 class="font-bold text-xl text-primary hover:text-accent-100"
																		 label="Standorte">
															<GsList class="ml-4 mb-4" tag="ul">
																<GsItem
																	v-for="obj in locations"
																	:key="obj.id"
																	:to="{name: 'standort-slug', params: { slug: obj.slug }}"
																	no-prefetch
																>
																	<GsItem-section
																		class="text-[1rem] lg:text-xl text-primary hover:text-accent-100">
																		{{ obj.name }}
																	</GsItem-section>
																</GsItem>
															</GsList>
														</GsExpansionItem>

														<GsExpansionItem
															class="font-bold text-xl text-primary hover:text-accent-100"
															label="Karriere">
															<GsList class="ml-4 mb-4" tag="ul">
																<template v-if="navigation && navigation.karriere">
																	<GsItem
																		v-for="(item,idx) in navigation.karriere"
																		:key="idx"
																		:to="item.path"
																		no-prefetch
																	>
																		<GsItem-section
																			class="text-[1rem] lg:text-xl text-primary hover:text-accent-100"
																		>
																			{{ item.label }}
																		</GsItem-section>
																	</GsItem>
																</template>
															</GsList>
														</GsExpansionItem>

														<GsExpansionItem
															class="font-bold text-xl text-primary hover:text-accent-100"
															label="Unternehmen">
															<GsList class="ml-4 mb-4" tag="ul">
																<template v-if="navigation && navigation.unternehmen">
																	<GsItem
																		v-for="(item,idx) in navigation.unternehmen"
																		:key="idx"
																		:to="item.path"
																		no-prefetch
																	>
																		<GsItem-section
																			class="text-[1rem] lg:text-xl text-primary hover:text-accent-100"
																		>
																			{{ item.label }}
																		</GsItem-section>
																	</GsItem>
																</template>
															</GsList>
														</GsExpansionItem>

														<GsItem no-prefetch to="/kontakt">
															<GsItem-section
																class="font-bold text-xl text-primary hover:text-accent-100">Kontakt
															</GsItem-section>
														</GsItem>

														<GsItem no-prefetch to="/datenschutzerklarung">
															<GsItem-section
																class="font-bold text-xl text-primary hover:text-accent-100">
																Datenschutz
															</GsItem-section>
														</GsItem>

														<GsItem no-prefetch to="/impressum">
															<GsItem-section
																class="font-bold text-xl text-primary hover:text-accent-100">
																Impressum
															</GsItem-section>
														</GsItem>

													</GsList>
												</nav>
											</div>
										</template>
									</UDrawer>
								</div>

							</div>
						</GsPageSection>

						<div v-if="$screen.gte.lg" class="bg-primary-200">
							<GsPageSection as="div" :class="{'justify-between':isScrolled}" container-class="px-4 h-12 flex justify-end">
								<NuxtLink :class="{'opacity-1':isScrolled, 'opacity-0':!isScrolled}" class="my-auto"
								          no-prefetch title="zur Startseite der Website der Kliniken Delitzsch Eilenburg"
								          to="/">
									<img alt="Logo der Kliniken Delitzsch Eilenburg" class="w-30" data-not-lazy height="70" src="@/assets/img/logo-white.svg" width="218"/>
								</NuxtLink>
								<div class="flex flex-row">

									<nav class="my-auto" role="navigation">
										<ul class="
											flex flex-row space-x-3 lg:space-x-8 xl:space-x-10 items-center
											[&>li>a]:h-12 [&>li>a]:inline-block [&>li>a]:items-center [&>li>a]:px-2
											[&>li>div>button]:h-12 [&>li>div>button]:px-2
										">
											<li>
												<GsBtnDropdown
													#="{ close }"
													:class="{'text-white': $route.path.includes('patienten')}"
													class="text-lg md:text-[1rem] lg:text-lg xl:text-xl font-bold text-primary hover:text-white duration-150"
													label="Patientenbereich"
													popup-class="p-4 w-[15rem] maw-w-1/6"
													slide
												>
													<ul class="text-primary-500 space-y-2">
														<li v-for="(item,idx) in navigation.patienten" :key="idx">
															<NuxtLink
																:to="item.path"
																active-class="bg-primary-50 text-accent-100"
																class="bg-gray-50 flex text-primary px-3 py-1 hover:bg-primary-50 hover:text-accent-100 font-bold whitespace-nowrap"
																no-prefetch
																@click="close"
															>
																{{ item.label }}
															</NuxtLink>
														</li>
													</ul>
												</GsBtnDropdown>
											</li>
											<li>
												<GsBtnDropdown
													#="{ close }"
													:class="{'text-white': $route.path.includes('fachbereich')}"
													:shift="0"
													class="text-lg md:text-[1rem] lg:text-lg xl:text-xl font-bold text-primary hover:text-white duration-150"
													label="Fachbereiche"
													placement="bottom-start"
													popup-class="p-4 w-screen xl:w-auto xl:left-auto xl:max-w-4xl"
													slide
												>
													<ul class="list-none text-primary-500 grid grid-cols-2 gap-2">
														<template v-if="subjectareas && subjectareas.length">
															<li v-for="obj in subjectareas" :key="obj.id">
																<NuxtLink
																	:to="{name: 'fachbereiche-slug', params: {slug: obj.slug}}"
																	active-class="bg-primary-50 text-accent-100"
																	class="
																		flex items-center h-full
																		bg-gray-50 text-primary font-semibold
																		px-3 py-1
																		hover:bg-primary-50 hover:text-accent-100
																		transition-all duration-150
																	"
																	no-prefetch
																	@click="close"
																>{{ obj.title }}
																</NuxtLink>
															</li>
														</template>
													</ul>
												</GsBtnDropdown>
											</li>
											<li v-if="locations && locations.length">
												<GsBtnDropdown
													#="{ close }"
													:class="{'text-white': $route.path.includes('standort')}"
													class="text-lg md:text-[1rem] lg:text-lg xl:text-xl font-bold text-primary hover:text-white duration-150 relative"
													label="Standorte"
													placement="bottom-start"
													popup-class="p-4 w-[200px] maw-w-1/6"
													slide
												>
													<ul class="text-primary-500 space-y-2">
														<li
															v-for="obj in locations"
															:key="obj.id"
														>
															<NuxtLink
																:to="{name: 'standort-slug', params: {slug: obj.slug}}"
																active-class="bg-primary-50 text-accent-100"
																class="bg-gray-50 flex text-primary px-3 py-1 hover:bg-primary-50 hover:text-accent-100 font-bold"
																no-prefetch
																@click="close"
															>
																{{ obj.name }}
															</NuxtLink>
														</li>
													</ul>
												</GsBtnDropdown>
											</li>
											<li v-else>
												<NuxtLink
													active-class="text-white"
													class="text-lg md:text-[1rem] lg:text-lg xl:text-xl font-bold text-primary hover:text-white duration-150"
													no-prefetch
													to="/"
												>
													Standorte
												</NuxtLink>
											</li>
											<li>
												<GsBtnDropdown
													#="{ close }"
													:class="{'text-white': $route.path.includes('karriere')}"
													class="text-lg md:text-[1rem] lg:text-lg xl:text-xl font-bold text-primary hover:text-white duration-150"
													label="Karriere"
													placement="bottom-start"
													popup-class="p-4 w-[285px] maw-w-1/6"
													slide
												>
													<ul class="text-primary-500 space-y-2">
														<li v-for="(item,idx) in navigation.karriere" :key="idx">
															<NuxtLink
																:to="item.path"
																active-class="bg-primary-50 text-accent-100"
																class="bg-gray-50 flex text-primary px-3 py-1 hover:bg-primary-50 hover:text-accent-100 font-bold"
																no-prefetch
																nuxt-client @click="close"
															>
																{{ item.label }}
															</NuxtLink>
														</li>
													</ul>
												</GsBtnDropdown>
											</li>
											<li>
												<GsBtnDropdown
													#="{ close }"
													:class="{'text-white': $route.path.includes('unternehmen')}"
													class="text-lg md:text-[1rem] lg:text-lg xl:text-xl font-bold text-primary hover:text-white duration-150"
													label="Unternehmen"
													placement="bottom-end"
													popup-class="p-4 w-[285px] maw-w-1/6"
													slide
												>
													<ul class="text-primary-500 space-y-2">
														<li v-for="(item,idx) in navigation.unternehmen" :key="idx">
															<NuxtLink
																:class="['hover:text-accent-100', {'hover:text-green-700' : item.label.includes('garten')}]"
																:to="item.path"
																active-class="bg-primary-50 text-accent-100"
																class="bg-gray-50 flex text-primary px-3 py-1 hover:bg-primary-50 font-bold"
																no-prefetch
																@click="close"
															>
																{{ item.label }}
																<GsIcon v-if="item.label.includes('garten')"
																        class="ms-2 mt-0.5" height="20" name="guidance:garden"
																        width="20"/>
																<GsIcon v-if="item.label.includes('garten')"
																        class="ms-0.5 mt-1.5" height="16" name="guidance:garden"
																        width="16"/>
																<GsIcon v-if="item.label.includes('garten')"
																        class="ms-0.5 mt-1" height="18" name="guidance:garden"
																        width="18"/>
															</NuxtLink>
														</li>
													</ul>
												</GsBtnDropdown>
											</li>
										</ul>
									</nav>

								</div>
							</GsPageSection>
						</div>
					</div>
				</div>
			</template>

			<NuxtPage/>

			<template #footer>
				<GsPageSection as="div" class="bg-primary opacity-75 text-white" container-class="px-4 xl:px-4 h-auto pt-20 pb-5">
					<div class="flex flex-col xs:flex-row gap-8 justify-between">
						<div class="flex items-center xs:items-start justify-center my-auto">
							<img v-lazy-load  alt="Logo der Kliniken Delitzsch Eilenburg"
								 class="w-1/2 xs:w-37.5 md:w-50 lg:w-63.75"
								 height="81" :data-src="usePublicUrl(logoFooterSrc)" :key="logoFooterSrc" width="255"
							/>
						</div>
						<div class="items-end">
							<div class="flex justify-center-safe xs:justify-end gap-x-5 lg:gap-x-10">
								<GsBtn to="https://www.facebook.com/Kreiskrankenhaus-Delitzsch-GmbH-Klinik-Delitzsch-Klinik-Eilenburg-239933522741422/" target="_blank" variant="link" color="white" icon="ri:facebook-fill" class="px-2.5! [&_.iconify]:me-0! [&_.iconify]:size-10 hover:[&_.iconify]:text-accent">
									<span class="sr-only">facebook Seite der Kliniken Delitzsch Eilenburg</span>
								</GsBtn>
								<GsBtn to="https://www.instagram.com/kliniken_delitzsch_eilenburg/" target="_blank" variant="link" color="white" icon="mdi:instagram" class="px-2.5! [&_.iconify]:me-0! [&_.iconify]:size-10 hover:[&_.iconify]:text-accent">
									<span class="sr-only">Instagram Seite der Kliniken Delitzsch Eilenburg</span>
								</GsBtn>
								<GsBtn to="https://de.linkedin.com/company/kliniken-delitzsch-eilenburg" target="_blank" variant="link" color="white" icon="ri:linkedin-fill" class="px-2.5! [&_.iconify]:me-0! [&_.iconify]:size-10 hover:[&_.iconify]:text-accent">
									<span class="sr-only">LinkedIn Profil der Kliniken Delitzsch Eilenburg</span>
								</GsBtn>
							</div>
						</div>
					</div>
					<div class="grid grid-cols-12 my-16 lg:my-20 xl:mb-0 gap-y-10 gap-x-2 lg:gap-10">
						<div class="hidden md:flex col-span-3 lg:col-span-2">
							<nav aria-label="Footer-Navigation"
								 class="md:flex md:flex-col order-last lg:order-first space-y-3 lg:space-y-5 lg:mb-12" role="navigation">
								<template v-if="footer_navigation && footer_navigation.length">
									<NuxtLink v-for="(item,idx) in footer_navigation" :to="item.path"
											  class="text-white hover:text-accent" no-prefetch>
										{{ item.label }}
									</NuxtLink>
								</template>
							</nav>
						</div>
						<div class="col-span-12 md:col-span-9 lg:col-span-8 xl:col-span-6">
							<div class="flex flex-col md:flex-row space-y-10 md:space-y-0 md:space-x-5">
								<div class="flex">
									<img v-lazy-load  alt="Finanziert von der Europäischen Union - NextGenerationEU"
										 class="max-w-50 mx-auto xs:mx-0"
										 height="945" :data-src="usePublicUrl(euSignetFooterSrc)" :key="euSignetFooterSrc"
										 width="886"/>
								</div>
								<div class="flex flex-col xs:flex-row gap-y-2 xs:gap-x-4 xs:gap-y-0">
									<div>
										<div class='bg-white [html[data-contrast="high-dark"]_&]:bg-white! mt-2 p-2 flex'>
											<img v-lazy-load  alt="Signet Land Sachsen"
												 class="max-w-25 mx-auto xs:mx-0" height="150"
												 :data-src="usePublicUrl('/img/Sachsen_Signet_gruen.svg')" width="100"/>
										</div>
									</div>
									<div class="lg:w-55 2xl:w-75">
										<p class="text-sm md:text-md lg:text-[1rem] text-white text-center xs:text-left">
											Diese Maßnahme wird mitfinanziert mit Steuermitteln auf Grundlage des
											vom Sächsischen Landtag beschlossenen Haushaltes.
										</p>
									</div>
								</div>
							</div>
						</div>
						<template v-if="locations && locations.length">
							<div
								v-for="(l,idx) in locations" :key="idx"
								class="col-span-full xs:col-span-6 md:col-span-4 lg:col-span-3 xl:col-span-2 text-sm md:text-[1rem]"
							>
								<div>
									<address class="not-italic">
										<span class="font-bold block">Klinik {{ l.name }}</span>
										{{ l.address.streetname }} {{ l.address.housenumber }}<br>
										{{ l.address.zipcode }} {{ l.address.city }}
									</address>
									<ul>
										<li v-if="l.phone_number" class="mt-4">
											<a :href="`tel:${l.phone_number}`" class="flex items-center justify-start text-white group hover:text-accent" title="jetzt anrufen">
												<GsIcon name="ph:phone" class="size-4.5 lg:size-5.5 text-white me-1.5 group-hover:text-accent" />
												<span>{{ l.phone_number }}</span>
											</a>
										</li>
										<li class="mt-4">
											<NuxtLink class="flex items-center justify-start  text-white group hover:text-accent" no-prefetch
													  to="/kontakt">
												<GsIcon name="clarity:form-line" class="size-4.5 lg:size-5.5 text-white me-1.5 group-hover:text-accent" />
												<span>Kontaktformular</span>
											</NuxtLink>
										</li>
										<li class="mt-4">
											<NuxtLink
												:to="l.slug ? {name: 'standort-slug', params: {slug: l.slug}} : '#'"
												class="flex items-center justify-start text-white group hover:text-accent"
												no-prefetch
											>
												<GsIcon name="bxs:map" class="size-4.5 lg:size-5.5 text-white me-1.5 group-hover:text-accent" />
												<span>Anfahrt</span>
											</NuxtLink>
										</li>
									</ul>
								</div>
							</div>
						</template>
					</div>
				</GsPageSection>

				<GsPageSection class="bg-primary-500" container-class="px-4 lg:px-4 py-5">
					<p class="text-[0.875rem] text-white text-center">
						Copyright &copy;
						<template v-if="currentDate">{{ currentDate.getFullYear() }} -</template>
						<template v-if="locations && locations.length">{{ locations[0].company_name }}</template>
						<template v-else>Kreiskrankenhaus Delitzsch GmbH</template>
					</p>
				</GsPageSection>
			</template>
		</NuxtLayout>
	</GsApp>
</template>
